// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard-specific styles (supplements reports.css) */

/* Static chart line animation - dashboard only */
.chart-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65%;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.4), rgba(233, 75, 108, 0.12), rgba(142, 58, 154, 0.4));
  clip-path: polygon(
    0% 100%,
    5% 85%,
    10% 75%,
    15% 80%,
    20% 70%,
    25% 60%,
    30% 65%,
    35% 55%,
    40% 50%,
    45% 45%,
    50% 40%,
    55% 35%,
    60% 30%,
    65% 35%,
    70% 25%,
    75% 20%,
    80% 25%,
    85% 20%,
    90% 15%,
    95% 10%,
    100% 8%,
    100% 100%
  );
  animation: chartReveal 1.8s ease 0.6s both;
  filter: blur(1px);
}

@keyframes chartReveal {
  from {
    clip-path: polygon(
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%,
      0% 100%
    );
  }
}

/* SVG trend chart positioning */
.trend-chart-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65%;
}

/* Chart placeholder with grid lines */
.chart-placeholder {
  height: 320px;
  background:
    linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 49px,
      rgba(0, 0, 0, 0.03) 49px,
      rgba(0, 0, 0, 0.03) 50px
    );
  border-radius: 12px;
  position: relative;
  overflow: visible;
}

/* Interactive Dashboard Chart */
.dashboard-chart-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: crosshair;
}

.dashboard-chart-svg {
  width: 100%;
  height: 100%;
  display: block;
}

/* Dashboard chart tooltip - positioned relative to wrapper */
.dashboard-chart-wrapper .chart-tooltip {
  position: absolute;
  background: rgba(30, 30, 40, 0.95);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  padding: 12px 16px;
  pointer-events: none;
  z-index: 1000;
  transform: translateX(-50%);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: 140px;
  text-align: center;
  white-space: nowrap;
}

.dashboard-chart-wrapper .chart-tooltip-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dashboard-chart-wrapper .chart-tooltip-value {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.dashboard-chart-wrapper .chart-tooltip-change {
  font-size: 12px;
  font-weight: 500;
}

.dashboard-chart-wrapper .chart-tooltip-change.positive {
  color: #2ecc71;
}

.dashboard-chart-wrapper .chart-tooltip-change.negative {
  color: #FF6B4A;
}

/* Chart dots (HTML elements, not SVG) */
.chart-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 10;
}

.chart-dot.hover-dot {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-dot-inner {
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.chart-dot.end-dot {
  width: 12px;
  height: 12px;
}

/* Currency value & tooltip styles moved to currency-value.css so that the
   shared CurrencyValue component drags them in wherever it's used. */

/* Month boundary markers */
.month-boundary {
  position: absolute;
  bottom: 10px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  z-index: 5;
}

.month-label {
  font-size: 11px;
  color: var(--text-tertiary, #999);
  white-space: nowrap;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
}

.month-label.prev {
  transform: translateX(-100%) translateX(-8px);
  position: absolute;
  left: 0;
}

.month-label.next {
  transform: translateX(8px);
  position: absolute;
  left: 0;
}

/* Min/Max value markers */
.value-marker {
  position: absolute;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.value-marker-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.max-marker .value-marker-dot {
  background: #2ecc71;
}

.min-marker .value-marker-dot {
  background: #e74c3c;
}

.value-marker-label {
  position: absolute;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.max-marker .value-marker-label {
  bottom: calc(100% + 6px);
  color: #27ae60;
}

.min-marker .value-marker-label {
  top: calc(100% + 6px);
  color: #c0392b;
}

/* Average value marker */
.avg-marker {
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 6;
}

.avg-label {
  font-size: 11px;
  font-weight: 600;
  color: #8E3A9A;
  background: linear-gradient(135deg, #f9f5fa, #faf6f8);
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  border: 1px solid rgba(142, 58, 154, 0.2);
  letter-spacing: 0.3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* ========================================
   Skeleton Loading Styles
   ======================================== */

/* Base skeleton animation */
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite ease-in-out;
  border-radius: 6px;
}

/* Stat card skeleton */
.stat-card.skeleton {
  padding: 20px;
}

.stat-card.skeleton .skeleton-label {
  width: 60px;
  height: 14px;
  margin-bottom: 12px;
}

.stat-card.skeleton .skeleton-value {
  width: 120px;
  height: 32px;
  margin-bottom: 8px;
}

.stat-card.skeleton .skeleton-comparison {
  width: 100px;
  height: 12px;
}

/* Campaign card skeleton */
.active-campaign-card.skeleton {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.active-campaign-card.skeleton .skeleton-title {
  width: 70%;
  height: 20px;
  margin-bottom: 8px;
}

.active-campaign-card.skeleton .skeleton-subtitle {
  width: 40%;
  height: 14px;
  margin-bottom: 16px;
}

.active-campaign-card.skeleton .skeleton-progress {
  width: 100%;
  height: 8px;
  margin-bottom: 20px;
}

.active-campaign-card.skeleton .skeleton-metrics {
  display: flex;
  gap: 16px;
}

.active-campaign-card.skeleton .skeleton-metric {
  width: 60px;
  height: 40px;
}

/* Chart skeleton */
.performance-card.skeleton {
  background: white;
  border-radius: 12px;
  padding: 20px;
  height: 320px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.skeleton-chart {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f5f5f5 25%, #ebebeb 50%, #f5f5f5 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite ease-in-out;
  border-radius: 8px;
}

/* Dashboard grid layout for skeleton */
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 24px;
  margin-top: 24px;
}

.active-campaigns-section .campaigns-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.chart-section {
  display: flex;
  flex-direction: column;
}

/* ========================================
   Mobile Responsive Styles
   ======================================== */

/* Tablet (768px - 1024px) */
@media (max-width: 1024px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .analytics-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .chart-tabs {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .chart-tabs::-webkit-scrollbar {
    display: none;
  }
}

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  /* Header - stack vertically */
  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
    padding-bottom: 16px;
  }

  .header-title h1 {
    font-size: 24px;
  }

  .header-subtitle {
    font-size: 13px;
  }

  .header-actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .header-actions .btn {
    flex: 1 1;
    justify-content: center;
    padding: 12px 14px;
    min-height: 44px;
    font-size: 13px;
  }

  /* Stats Grid - 2x2 on mobile, compact */
  .stats-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px;
    margin-bottom: 20px;
  }

  .stat-card {
    padding: 14px;
    border-radius: 10px;
  }

  .stat-card::after {
    display: none; /* Hide decorative gradient */
  }

  .stat-header {
    margin-bottom: 8px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-badge {
    padding: 3px 6px;
    font-size: 10px;
    gap: 2px;
  }

  .stat-badge svg {
    width: 8px;
    height: 8px;
  }

  .stat-value {
    font-size: 22px;
    margin-bottom: 4px;
  }

  .stat-comparison {
    font-size: 10px;
  }

  /* Currency scaling on mobile */
  .currency-symbol.large {
    font-size: 0.6em;
    margin-right: 2px;
  }

  .currency-cents.large {
    font-size: 0.55em;
  }

  /* Section titles */
  .section-title {
    font-size: 18px;
  }

  .section-title::after {
    width: 40px;
    height: 2px;
    bottom: -4px;
  }

  .section-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
  }

  .section-header .btn {
    padding: 8px 14px;
    font-size: 12px;
  }

  /* Campaigns Section */
  .campaigns-section {
    margin-bottom: 20px;
  }

  /* Campaign Grid */
  .campaign-grid {
    gap: 12px;
  }

  .campaign-card {
    padding: 14px;
    border-radius: 10px;
  }

  .campaign-card::after {
    display: none; /* Hide decorative gradient */
  }

  .campaign-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
  }

  .campaign-info {
    flex: 1 1;
    min-width: 0;
  }

  .campaign-info h3 {
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }

  .campaign-status {
    font-size: 11px;
  }

  .status-dot {
    width: 6px;
    height: 6px;
  }

  .campaign-budget {
    flex-shrink: 0;
    text-align: right;
    min-width: 100px;
  }

  .budget-label {
    font-size: 10px;
    margin-bottom: 2px;
  }

  .budget-value {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .budget-bar {
    height: 4px;
  }

  /* Campaign Metrics - 4 in a row, compact */
  .campaign-metrics {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
    background: var(--bg-tertiary);
    border-radius: 8px;
    padding: 10px;
  }

  .metric {
    text-align: center;
    padding: 0;
  }

  .metric-value {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
  }

  .metric-label {
    font-size: 9px;
    text-transform: uppercase;
    color: var(--text-tertiary);
  }

  /* Analytics Section */
  .analytics-section {
    padding: 14px;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .analytics-section::before {
    display: none;
  }

  .analytics-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 14px;
  }

  .chart-tabs {
    display: flex;
    gap: 6px;
    width: 100%;
    background: var(--bg-tertiary);
    border-radius: 8px;
    padding: 4px;
  }

  .chart-tab {
    flex: 1 1;
    padding: 10px 8px;
    font-size: 12px;
    min-height: 40px;
    text-align: center;
    border: none;
    background: transparent;
  }

  .chart-tab.active {
    background: white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  /* Chart placeholder - shorter on mobile */
  .chart-placeholder {
    height: 200px;
    border-radius: 8px;
  }

  /* Chart tooltip - smaller on mobile */
  .dashboard-chart-wrapper .chart-tooltip {
    padding: 8px 10px;
    min-width: 100px;
    border-radius: 6px;
  }

  .dashboard-chart-wrapper .chart-tooltip-date {
    font-size: 9px;
  }

  .dashboard-chart-wrapper .chart-tooltip-value {
    font-size: 13px;
  }

  .dashboard-chart-wrapper .chart-tooltip-change {
    font-size: 10px;
  }

  /* Value markers - smaller on mobile */
  .value-marker-label {
    font-size: 9px;
    padding: 2px 4px;
  }

  .avg-label {
    font-size: 9px;
    padding: 2px 6px;
  }

  /* Month labels - hide on mobile (too crowded) */
  .month-boundary {
    display: none;
  }

  /* Skeleton loading - mobile adjustments */
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .active-campaign-card.skeleton {
    padding: 14px;
  }

  .performance-card.skeleton {
    height: 200px;
    padding: 14px;
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .header-title h1 {
    font-size: 20px;
  }

  .header-subtitle {
    font-size: 12px;
  }

  .header-actions .btn {
    padding: 10px 12px;
    font-size: 12px;
  }

  .stats-grid {
    gap: 8px;
  }

  .stat-card {
    padding: 12px;
  }

  .stat-value {
    font-size: 18px;
  }

  .stat-badge {
    padding: 2px 5px;
    font-size: 9px;
  }

  .stat-comparison {
    font-size: 9px;
  }

  .section-title {
    font-size: 16px;
  }

  .campaign-card {
    padding: 12px;
  }

  .campaign-info h3 {
    font-size: 14px;
  }

  .campaign-status {
    font-size: 10px;
  }

  .campaign-metrics {
    padding: 8px;
    gap: 4px;
  }

  .metric-value {
    font-size: 12px;
  }

  .metric-label {
    font-size: 8px;
  }

  .analytics-section {
    padding: 12px;
  }

  .chart-placeholder {
    height: 180px;
  }

  .chart-tab {
    padding: 8px 6px;
    font-size: 11px;
  }

  /* Hide min/max markers on very small screens */
  .value-marker {
    display: none;
  }

  .avg-marker {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD,iDAAiD;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,+GAA+G;EAC/G;;;;;;;;;;;;;;;;;;;;;;;GAuBC;EACD,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE;IACE;;;;;;;;;;;;;;;;;;;;;;;KAuBC;EACH;AACF;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb;;;;;;;;KAQG;EACH,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;qEACqE;;AAErE,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;6CAE6C;;AAE7C,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;6CAE6C;;AAE7C,4BAA4B;AAC5B;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,gDAAgD;IAChD,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,+CAA+C;EAC/C;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Dashboard-specific styles (supplements reports.css) */\n\n/* Static chart line animation - dashboard only */\n.chart-line {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 65%;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.4), rgba(233, 75, 108, 0.12), rgba(142, 58, 154, 0.4));\n  clip-path: polygon(\n    0% 100%,\n    5% 85%,\n    10% 75%,\n    15% 80%,\n    20% 70%,\n    25% 60%,\n    30% 65%,\n    35% 55%,\n    40% 50%,\n    45% 45%,\n    50% 40%,\n    55% 35%,\n    60% 30%,\n    65% 35%,\n    70% 25%,\n    75% 20%,\n    80% 25%,\n    85% 20%,\n    90% 15%,\n    95% 10%,\n    100% 8%,\n    100% 100%\n  );\n  animation: chartReveal 1.8s ease 0.6s both;\n  filter: blur(1px);\n}\n\n@keyframes chartReveal {\n  from {\n    clip-path: polygon(\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%,\n      0% 100%\n    );\n  }\n}\n\n/* SVG trend chart positioning */\n.trend-chart-svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 65%;\n}\n\n/* Chart placeholder with grid lines */\n.chart-placeholder {\n  height: 320px;\n  background:\n    linear-gradient(to top, transparent 0%, rgba(255, 107, 74, 0.03) 100%),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 49px,\n      rgba(0, 0, 0, 0.03) 49px,\n      rgba(0, 0, 0, 0.03) 50px\n    );\n  border-radius: 12px;\n  position: relative;\n  overflow: visible;\n}\n\n/* Interactive Dashboard Chart */\n.dashboard-chart-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: crosshair;\n}\n\n.dashboard-chart-svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n/* Dashboard chart tooltip - positioned relative to wrapper */\n.dashboard-chart-wrapper .chart-tooltip {\n  position: absolute;\n  background: rgba(30, 30, 40, 0.95);\n  backdrop-filter: blur(8px);\n  border-radius: 10px;\n  padding: 12px 16px;\n  pointer-events: none;\n  z-index: 1000;\n  transform: translateX(-50%);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  min-width: 140px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.dashboard-chart-wrapper .chart-tooltip-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dashboard-chart-wrapper .chart-tooltip-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.dashboard-chart-wrapper .chart-tooltip-change {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.dashboard-chart-wrapper .chart-tooltip-change.positive {\n  color: #2ecc71;\n}\n\n.dashboard-chart-wrapper .chart-tooltip-change.negative {\n  color: #FF6B4A;\n}\n\n/* Chart dots (HTML elements, not SVG) */\n.chart-dot {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.chart-dot.hover-dot {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chart-dot-inner {\n  width: 10px;\n  height: 10px;\n  background: white;\n  border-radius: 50%;\n}\n\n.chart-dot.end-dot {\n  width: 12px;\n  height: 12px;\n}\n\n/* Currency value & tooltip styles moved to currency-value.css so that the\n   shared CurrencyValue component drags them in wherever it's used. */\n\n/* Month boundary markers */\n.month-boundary {\n  position: absolute;\n  bottom: 10px;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n  z-index: 5;\n}\n\n.month-label {\n  font-size: 11px;\n  color: var(--text-tertiary, #999);\n  white-space: nowrap;\n  padding: 2px 8px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 4px;\n}\n\n.month-label.prev {\n  transform: translateX(-100%) translateX(-8px);\n  position: absolute;\n  left: 0;\n}\n\n.month-label.next {\n  transform: translateX(8px);\n  position: absolute;\n  left: 0;\n}\n\n/* Min/Max value markers */\n.value-marker {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: 8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.value-marker-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n}\n\n.max-marker .value-marker-dot {\n  background: #2ecc71;\n}\n\n.min-marker .value-marker-dot {\n  background: #e74c3c;\n}\n\n.value-marker-label {\n  position: absolute;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.max-marker .value-marker-label {\n  bottom: calc(100% + 6px);\n  color: #27ae60;\n}\n\n.min-marker .value-marker-label {\n  top: calc(100% + 6px);\n  color: #c0392b;\n}\n\n/* Average value marker */\n.avg-marker {\n  position: absolute;\n  right: 0;\n  transform: translateY(-50%);\n  pointer-events: none;\n  z-index: 6;\n}\n\n.avg-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #8E3A9A;\n  background: linear-gradient(135deg, #f9f5fa, #faf6f8);\n  padding: 4px 10px;\n  border-radius: 12px;\n  white-space: nowrap;\n  border: 1px solid rgba(142, 58, 154, 0.2);\n  letter-spacing: 0.3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n/* ========================================\n   Skeleton Loading Styles\n   ======================================== */\n\n/* Base skeleton animation */\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-line {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite ease-in-out;\n  border-radius: 6px;\n}\n\n/* Stat card skeleton */\n.stat-card.skeleton {\n  padding: 20px;\n}\n\n.stat-card.skeleton .skeleton-label {\n  width: 60px;\n  height: 14px;\n  margin-bottom: 12px;\n}\n\n.stat-card.skeleton .skeleton-value {\n  width: 120px;\n  height: 32px;\n  margin-bottom: 8px;\n}\n\n.stat-card.skeleton .skeleton-comparison {\n  width: 100px;\n  height: 12px;\n}\n\n/* Campaign card skeleton */\n.active-campaign-card.skeleton {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.active-campaign-card.skeleton .skeleton-title {\n  width: 70%;\n  height: 20px;\n  margin-bottom: 8px;\n}\n\n.active-campaign-card.skeleton .skeleton-subtitle {\n  width: 40%;\n  height: 14px;\n  margin-bottom: 16px;\n}\n\n.active-campaign-card.skeleton .skeleton-progress {\n  width: 100%;\n  height: 8px;\n  margin-bottom: 20px;\n}\n\n.active-campaign-card.skeleton .skeleton-metrics {\n  display: flex;\n  gap: 16px;\n}\n\n.active-campaign-card.skeleton .skeleton-metric {\n  width: 60px;\n  height: 40px;\n}\n\n/* Chart skeleton */\n.performance-card.skeleton {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  height: 320px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.skeleton-chart {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, #f5f5f5 25%, #ebebeb 50%, #f5f5f5 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite ease-in-out;\n  border-radius: 8px;\n}\n\n/* Dashboard grid layout for skeleton */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 24px;\n  margin-top: 24px;\n}\n\n.active-campaigns-section .campaigns-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.chart-section {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ========================================\n   Mobile Responsive Styles\n   ======================================== */\n\n/* Tablet (768px - 1024px) */\n@media (max-width: 1024px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .analytics-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .chart-tabs {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .chart-tabs::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/* Mobile (max-width: 768px) */\n@media (max-width: 768px) {\n  /* Header - stack vertically */\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n  }\n\n  .header-title h1 {\n    font-size: 24px;\n  }\n\n  .header-subtitle {\n    font-size: 13px;\n  }\n\n  .header-actions {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .header-actions .btn {\n    flex: 1;\n    justify-content: center;\n    padding: 12px 14px;\n    min-height: 44px;\n    font-size: 13px;\n  }\n\n  /* Stats Grid - 2x2 on mobile, compact */\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n\n  .stat-card {\n    padding: 14px;\n    border-radius: 10px;\n  }\n\n  .stat-card::after {\n    display: none; /* Hide decorative gradient */\n  }\n\n  .stat-header {\n    margin-bottom: 8px;\n  }\n\n  .stat-label {\n    font-size: 11px;\n  }\n\n  .stat-badge {\n    padding: 3px 6px;\n    font-size: 10px;\n    gap: 2px;\n  }\n\n  .stat-badge svg {\n    width: 8px;\n    height: 8px;\n  }\n\n  .stat-value {\n    font-size: 22px;\n    margin-bottom: 4px;\n  }\n\n  .stat-comparison {\n    font-size: 10px;\n  }\n\n  /* Currency scaling on mobile */\n  .currency-symbol.large {\n    font-size: 0.6em;\n    margin-right: 2px;\n  }\n\n  .currency-cents.large {\n    font-size: 0.55em;\n  }\n\n  /* Section titles */\n  .section-title {\n    font-size: 18px;\n  }\n\n  .section-title::after {\n    width: 40px;\n    height: 2px;\n    bottom: -4px;\n  }\n\n  .section-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 14px;\n  }\n\n  .section-header .btn {\n    padding: 8px 14px;\n    font-size: 12px;\n  }\n\n  /* Campaigns Section */\n  .campaigns-section {\n    margin-bottom: 20px;\n  }\n\n  /* Campaign Grid */\n  .campaign-grid {\n    gap: 12px;\n  }\n\n  .campaign-card {\n    padding: 14px;\n    border-radius: 10px;\n  }\n\n  .campaign-card::after {\n    display: none; /* Hide decorative gradient */\n  }\n\n  .campaign-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  .campaign-info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .campaign-info h3 {\n    font-size: 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 4px;\n  }\n\n  .campaign-status {\n    font-size: 11px;\n  }\n\n  .status-dot {\n    width: 6px;\n    height: 6px;\n  }\n\n  .campaign-budget {\n    flex-shrink: 0;\n    text-align: right;\n    min-width: 100px;\n  }\n\n  .budget-label {\n    font-size: 10px;\n    margin-bottom: 2px;\n  }\n\n  .budget-value {\n    font-size: 12px;\n    margin-bottom: 4px;\n  }\n\n  .budget-bar {\n    height: 4px;\n  }\n\n  /* Campaign Metrics - 4 in a row, compact */\n  .campaign-metrics {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 6px;\n    background: var(--bg-tertiary);\n    border-radius: 8px;\n    padding: 10px;\n  }\n\n  .metric {\n    text-align: center;\n    padding: 0;\n  }\n\n  .metric-value {\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 2px;\n  }\n\n  .metric-label {\n    font-size: 9px;\n    text-transform: uppercase;\n    color: var(--text-tertiary);\n  }\n\n  /* Analytics Section */\n  .analytics-section {\n    padding: 14px;\n    border-radius: 10px;\n    margin-bottom: 20px;\n  }\n\n  .analytics-section::before {\n    display: none;\n  }\n\n  .analytics-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  .chart-tabs {\n    display: flex;\n    gap: 6px;\n    width: 100%;\n    background: var(--bg-tertiary);\n    border-radius: 8px;\n    padding: 4px;\n  }\n\n  .chart-tab {\n    flex: 1;\n    padding: 10px 8px;\n    font-size: 12px;\n    min-height: 40px;\n    text-align: center;\n    border: none;\n    background: transparent;\n  }\n\n  .chart-tab.active {\n    background: white;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  }\n\n  /* Chart placeholder - shorter on mobile */\n  .chart-placeholder {\n    height: 200px;\n    border-radius: 8px;\n  }\n\n  /* Chart tooltip - smaller on mobile */\n  .dashboard-chart-wrapper .chart-tooltip {\n    padding: 8px 10px;\n    min-width: 100px;\n    border-radius: 6px;\n  }\n\n  .dashboard-chart-wrapper .chart-tooltip-date {\n    font-size: 9px;\n  }\n\n  .dashboard-chart-wrapper .chart-tooltip-value {\n    font-size: 13px;\n  }\n\n  .dashboard-chart-wrapper .chart-tooltip-change {\n    font-size: 10px;\n  }\n\n  /* Value markers - smaller on mobile */\n  .value-marker-label {\n    font-size: 9px;\n    padding: 2px 4px;\n  }\n\n  .avg-label {\n    font-size: 9px;\n    padding: 2px 6px;\n  }\n\n  /* Month labels - hide on mobile (too crowded) */\n  .month-boundary {\n    display: none;\n  }\n\n  /* Skeleton loading - mobile adjustments */\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .active-campaign-card.skeleton {\n    padding: 14px;\n  }\n\n  .performance-card.skeleton {\n    height: 200px;\n    padding: 14px;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  .header-title h1 {\n    font-size: 20px;\n  }\n\n  .header-subtitle {\n    font-size: 12px;\n  }\n\n  .header-actions .btn {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .stats-grid {\n    gap: 8px;\n  }\n\n  .stat-card {\n    padding: 12px;\n  }\n\n  .stat-value {\n    font-size: 18px;\n  }\n\n  .stat-badge {\n    padding: 2px 5px;\n    font-size: 9px;\n  }\n\n  .stat-comparison {\n    font-size: 9px;\n  }\n\n  .section-title {\n    font-size: 16px;\n  }\n\n  .campaign-card {\n    padding: 12px;\n  }\n\n  .campaign-info h3 {\n    font-size: 14px;\n  }\n\n  .campaign-status {\n    font-size: 10px;\n  }\n\n  .campaign-metrics {\n    padding: 8px;\n    gap: 4px;\n  }\n\n  .metric-value {\n    font-size: 12px;\n  }\n\n  .metric-label {\n    font-size: 8px;\n  }\n\n  .analytics-section {\n    padding: 12px;\n  }\n\n  .chart-placeholder {\n    height: 180px;\n  }\n\n  .chart-tab {\n    padding: 8px 6px;\n    font-size: 11px;\n  }\n\n  /* Hide min/max markers on very small screens */\n  .value-marker {\n    display: none;\n  }\n\n  .avg-marker {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
